import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import TypewriterText from '../../components/TypewriterText';

const OnboardingStep9 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const progress = (9 / 14) * 100;

  return (
    <OnboardingLayout progress={progress}>
      <div className="bg-white border-3 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>
        <div className="text-center mb-8">

          <div className="text-center mb-8">
            <h1
              className="text-2xl text-center text-[#077f5d] mb-4 uppercase"
              style={{ fontFamily: "'Press Start 2P'", lineHeight: '1.3' }}
            >
              {t('onboarding.step9.title')}
            </h1>
            <div className="space-y-3 mb-6">
              <TypewriterText
                texts={[
                  t('onboarding.step9.subtitle')
                ]}
                speed={35}
                delayBetween={500}
                showCursor={true}
                className="text-[#1a1a1a] font-mono text-center"
                onFinish={() => console.log('Typing done')}
                startOnView={true}
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          onClick={() => navigate('/onboarding/step-10')}
          className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase"
          style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: '12px',
            boxShadow: '6px 6px 0 #077f5d'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(0, 0)';
          }}
        >
          {t('onboarding.step9.next')}
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep9;
